import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environment/environment";

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  httpOptions:any;
  constructor(private httpClient: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    };
  }
  
  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }
  chatwebhook(FormDetails: any) {
    return this.httpClient.post<Array<any>>(environment.Pythonurl + "/handle_message", FormDetails, this.httpOptions);
  }
}
